// @flow
import React, { Component } from 'react';
import { type ContextRouter, withRouter } from 'react-router-dom';
import queryString from 'query-string';
import './SearchBox.scss';

type Props = {
  onSearch(keyword: string): any,
  currentMenu: string,
} & ContextRouter;

type State = {
  value: string,
  focus: boolean,
  menu: string,
  currentMenu: string,
  autoComplete: boolean,
};

class SearchBox extends Component<Props, State> {
  input = React.createRef();

  constructor(props: Props) {
    super(props);
    this.state = {
      value: '',
      focus: false,
      menu: '',
      currentMenu: '',
      autoComplete: false,
    };
    const { q, menu } = queryString.parse(this.props.location.search);
    if (q || menu) {
      this.state.value = q.trim();
      this.state.menu = menu;
    }
  }

  onSearch = () => {
    const { value, menu, currentMenu } = this.state;
    const { facets, sort } = queryString.parse(this.props.location.search);

    // URL에서 facets와 sort 파라미터도 함께 전달
    const parsedFacets = facets ? JSON.parse(facets) : {};
    this.props.onSearch(value, currentMenu || menu, parsedFacets, sort);
  };

  componentDidMount() {
    const { value, menu } = this.state;
    if (value || menu) {
      this.onSearch();
    }
  }

  render() {
    return true;
  }
}

export default withRouter(SearchBox);



// WEBPACK FOOTER //
// ./src/components/search/SearchBox/SearchBox.js